import * as angular from "angular";

export interface IRLScrollFixedScope extends ng.IScope {
    topOffset: number;
}

RLScrollFixed.$inject = ["$window"];
export function RLScrollFixed($window: ng.IWindowService) {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var expanded = false;

            var expand = () => {
                element.addClass("scroll-fixed");
                expanded = true;
            };

            var collapse = () => {
                element.removeClass("scroll-fixed");
                expanded = false;
            };

            var initialTopPosition;

            var checkScroll = () => {

                if (element.is(":visible")) {
                    // there be magic numbers below, proceed with caution
                    if (angular.element('.rl-content').innerHeight() > element.innerHeight() + 150) {
                        if (!initialTopPosition || initialTopPosition === 0) {
                            initialTopPosition = element.parent().offset().top - 50;
                        }
                        var scrollTop = $(document).scrollTop();
                        if (scrollTop > initialTopPosition && !expanded) {
                            expand();
                        } else if (scrollTop <= initialTopPosition && expanded) {
                            collapse();
                        }
                    }
                }
            }

            var observer = new MutationObserver((mutations) => {
                checkScroll();
            });

            observer.observe(element[0], { attributes: true });

            $(document).on("scroll", () => {
                checkScroll();
            });

            angular.element($window).bind('resize', () => {
                checkScroll();
            });

            $(document).on("show.bs.modal", ".modal", () => { collapse(); });
        }
    };
    return directive;
}

